import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBB_U1JNwurTdY3HvHcrhORCEEwcqhd8SQ",
    authDomain: "vyralnet-ccefb.firebaseapp.com",
    projectId: "vyralnet-ccefb",
    storageBucket: "vyralnet-ccefb.firebasestorage.app",
    messagingSenderId: "946624041577",
    appId: "1:946624041577:web:a1ee5ab22e65997d0148f8",
    measurementId: "G-Q9YDQZ6STB"
};

const firebase = initializeApp(firebaseConfig);
const db = getFirestore(firebase);
const firebaseAuth = getAuth(firebase);

export { db, firebase, firebaseAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup };